import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonReRegistrationArticulationList = () => {
    return (
        Array(3)
            .fill()
            .map((_, index) => (
                <div key={index} style={{ width: '100%' }}>
                    <Skeleton width='100%' height={364} />
                </div>
            ))
    );
};
export default SkeletonReRegistrationArticulationList;
